import React, { useState } from 'react';
import SearchInput from 'src/components/search-input/search-input';
import { useCreateClientMutation, useGetOrganizationClientsQuery } from 'src/redux/organization/organization.endpoints';
import { Button } from 'src/components/ui/button';
import { Plus } from 'lucide-react';
import ManageClientsTable from '../components/manage-clients/manage-clients-table';
import { Client } from '../types/client.types';
import { ManageClientDrawer } from '../components/manage-clients/manage-client-drawer';
import { useActiveClient } from 'src/redux/active-client/use-active-client';
import notificationService from 'src/services/notification/notification.service';
import { useDispatch } from 'react-redux';
import { adjectives, animals, colors, uniqueNamesGenerator } from 'unique-names-generator';

const ManageClientsTab: React.FC = () => {
  const { setClient } = useActiveClient();
  const dispatch = useDispatch();
  const [showClientDrawer, setShowClientDrawer] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [showClientCreationComponent, setShowClientCreationComponent] = useState(false);

  const { data: clients, isLoading: isLoadingClients, isFetching: isFetchingClients } = useGetOrganizationClientsQuery();
  const [createClient, { isLoading: isLoadingCreateClient }] = useCreateClientMutation();

  const handleClientSelect = (client: Client) => {
    setClient(client);
    setShowClientDrawer(true);
  };

  const handleClientCreate = async() => {
    try {
      const randomName = uniqueNamesGenerator({
        dictionaries: [adjectives, colors, animals],
        separator: ' ',
        length: 3,
        style: 'capital',
      });


      const response = await createClient({
        title: randomName,
      }).unwrap();
      setClient(response);
      setShowClientDrawer(true);
    } catch (error) {
      console.error('Failed to create client:', error);
      notificationService.handleError(null, dispatch, 'Failed to create client');
    }
  };

  return (
    <>
      <div className="h-full flex flex-col space-y-4">
        {/* Header */}
        <div className="">
          <div className="flex flex-row gap-4 w-full items-center justify-between pb-1">
            <div>
              <SearchInput
                placeholder="Search clients..."
                value={searchValue}
                onChange={setSearchValue}
                debounceMs={500}
                className="w-96 rounded-full"
                inputClassName='bg-white rounded-full '
              />
            </div>
            {/* <div className="flex items-center gap-2">

          </div> */}
          </div>
        </div>

        {/* Content */}
        <div className="overflow-auto relative rounded-lg shadow-md bg-white">
          <div className='flex flex-row gap-2 justify-end bg-white border-b border-gray-201'>
            <Button
              size='med'
              variant='ghost'
              onClick={(() => {
                handleClientCreate();
              })}
              className={`flex flex-col hover:bg-gray-201 rounded-none p-8 px-4 pb-8 text-sm gap-1 border-l border-gray-201 ${showClientCreationComponent ? 'bg-gray-201' : ''}`}
            >
              <Plus className="h-4 w-4" />
              New
            </Button>
          </div>
          <div className='overflow-visible'>
            <ManageClientsTable
              clients={clients ?? []}
              loading={isLoadingClients || isFetchingClients}
              isCreation={showClientCreationComponent}
              className='overflow-visible'
              onClientSelect={handleClientSelect}
            />
          </div>

        </div>
      </div>
      <ManageClientDrawer
        open={showClientDrawer}
        // initialActiveAction={showClientCreationComponent ? 'views' : 'permissions'}
        onOpenChange={setShowClientDrawer}
      />
    </>
  );
};

export default ManageClientsTab;
